module.exports = __webpack_public_path__ + "static/media/02.f5f07dce.png";